import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import style from './MobileCardList.module.scss';

import { MobileCardData, MobileField } from './types';
import { MobileCard } from '@components/MobileCardList/MobileCard';
import { store } from '@store';

interface Props<D extends MobileCardData = any> {
    data: D[];
    fields: MobileField<D>[];
    loadMoreItems?: () => Promise<void>;
    onCardClick(params: D, e: React.MouseEvent, index?: number): void;
    onActionButtonClick?(index: number): void;
}

export const MobileCardList = observer(function MobileCardList<D extends MobileCardData = any>({
    data,
    fields,
    onCardClick,
    onActionButtonClick,
    loadMoreItems,
}: Props<D>): React.ReactElement {
    const { viewPort, app } = store;

    async function loader() {
        if (loadMoreItems) {
            app.setIsOnUpdate(true);
            await loadMoreItems();
            app.setIsOnUpdate(false);
        }
    }

    useEffect(() => {
        viewPort.setOnPageEndHandler(loader);

        return () => {
            viewPort.setOnPageEndHandler();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ul className={style.root}>
            {data.map((dataItem, index) => (
                <MobileCard<D>
                    key={dataItem.id || dataItem.recordId}
                    index={index}
                    fields={fields}
                    dataItem={dataItem}
                    onActionButtonClick={onActionButtonClick}
                    onCardClick={onCardClick}
                />
            ))}
        </ul>
    );
}) as <D extends MobileCardData = any>(props: Props<D>) => React.ReactElement;
